import {IPrice} from "./Offer";

interface IOfferPriceViewProps {
    price: IPrice
}

export default function OfferPriceView(props: IOfferPriceViewProps) {
    return <div className="Offer_price_view_container">
        <span>{props.price.prefix}</span>
        <div className="Offer_price_view_price">{props.price.price}</div>
        <span>{props.price.suffix}</span>
    </div>
}